import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";

// One Lenis instance for the whole site; ScrollToTop reaches it through getLenis().
let lenis = null;

export function getLenis() {
  return lenis;
}

// Eases mouse-wheel scrolling across every page. Touch scrolling stays native, nested
// scroll areas (tables, menus) keep their own scrolling, and visitors who prefer reduced
// motion get Lenis' 1:1 scrolling.
export default function SmoothScroll() {
  useEffect(() => {
    lenis = new Lenis({
      autoRaf: true,
      lerp: 0.1,
      wheelMultiplier: 1,
      allowNestedScroll: true,
      stopInertiaOnNavigate: true,
    });

    return () => {
      lenis.destroy();
      lenis = null;
    };
  }, []);

  return null;
}
